import React from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { useQuery } from 'react-apollo';

import FullScreenLoader from '../../../../../../components/global/FullScreenLoader';
import { ALBUM_SLIDESHOW_MODE } from '../../../../../../constants/albums';
import VideoSlideshowDesignerView from '../../VideoSlideshow/VideoSlideshowDesignerView';
import AlbumSlideshowDesignerView from '../../AlbumSlideshow/AlbumSlideshowDesignerView';
import { AlbumSlideshowForModeCheck } from '../../../../../../graphql/queries/albums';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumId: PropTypes.string,
    }),
  }),
};

const SlideshowDesignerView = ({ match }) => {
  const { albumId } = match.params;
  const { data: { loading, album } = {} } = useQuery(
    AlbumSlideshowForModeCheck,
    {
      variables: {
        id: albumId,
      },
      skip: !albumId,
    },
  );

  if (loading || !album || !album?.slideshow) {
    return <FullScreenLoader />;
  }

  if (album?.slideshow?.mode === ALBUM_SLIDESHOW_MODE.ALL_VIDEOS) {
    return <VideoSlideshowDesignerView />;
  }

  return <AlbumSlideshowDesignerView />;
};

SlideshowDesignerView.propTypes = propTypes;

export default compose(withRouter)(SlideshowDesignerView);
